import { Expose } from "class-transformer";
import { IsNumber } from "class-validator";

export class CalculatePaymentSummaryResponse {
  @Expose()
  @IsNumber()
  grossLeftToPay!: number;
  @Expose()
  @IsNumber()
  grossInCurrencyLeftToPay!: number;
}
